import AWS from 'aws-sdk';
import store from '../store'; // Asegúrate que esta ruta a tu store sea correcta.
import { decryptData } from './cryptoUtils';

let awsConfigured = false;

const configureAwsSdk = () => {
  // Si ya está configurado y no queremos forzar reconfiguración, salimos.
  // Podrías añadir lógica para verificar si las credenciales en Redux cambiaron.
  if (awsConfigured) {
    return;
  }

  const state = store.getState();
  const awsAuthState = state.awsAuth; // Esta es la ruta a nuestro reducer awsAuth

  if (awsAuthState && awsAuthState.encryptedCredentials) {
    const { region, accessKeyId: encryptedAccessKeyId, secretAccessKey: encryptedSecretAccessKey } = awsAuthState.encryptedCredentials;

    if (!region || !encryptedAccessKeyId || !encryptedSecretAccessKey) {
      console.error('Credenciales AWS encriptadas incompletas en Redux store.');
      awsConfigured = false;
      return;
    }

    const decryptedAccessKeyId = decryptData(encryptedAccessKeyId);
    const decryptedSecretAccessKey = decryptData(encryptedSecretAccessKey);

    if (decryptedAccessKeyId && decryptedSecretAccessKey) {
      AWS.config.update({
        region: region,
        accessKeyId: decryptedAccessKeyId,
        secretAccessKey: decryptedSecretAccessKey,
      });
      console.log('SDK de AWS configurado exitosamente desde Redux store.');
      awsConfigured = true;
    } else {
      console.error('Fallo al descifrar credenciales AWS desde Redux store.');
      awsConfigured = false;
    }
  } else {
    console.warn('Credenciales AWS no encontradas en Redux store. SDK de AWS no configurado.');
    awsConfigured = false;
  }
};

// Intenta configurar el SDK cuando este módulo se carga por primera vez.
// Esto es importante: el SDK se configurará con lo que haya en Redux en ese momento.
// Si las credenciales se obtienen DESPUÉS de que este módulo se importe, podría no estar configurado.
configureAwsSdk();

// Nos suscribimos a cambios en el store de Redux para reconfigurar si es necesario.
// Esto es útil si las credenciales cambian o se establecen después de la carga inicial.
let reconfigureTimeout = null;
const DEDUP_TIMEOUT = 1000; // 1 segundo de debounce

store.subscribe(() => {
  if (reconfigureTimeout) {
    clearTimeout(reconfigureTimeout);
  }
  reconfigureTimeout = setTimeout(() => {
    const currentState = store.getState();
    const currentEncryptedCreds = currentState.awsAuth && currentState.awsAuth.encryptedCredentials;
    // Reconfigura si no estaba configurado O si hay nuevas credenciales y antes no estaba configurado.
    // Una lógica más avanzada podría comparar las credenciales anteriores y nuevas si fuera necesario.
    if (!awsConfigured || (currentEncryptedCreds && !awsConfigured)) {
        console.log('Estado de AWS auth cambió en Redux, intentando reconfigurar SDK de AWS.');
        awsConfigured = false; // Forzar el intento de reconfiguración
        configureAwsSdk();
    }
  }, DEDUP_TIMEOUT);
});

// Exporta una función para obtener el objeto AWS, asegurando que se intente la configuración.
export const getAwsSdk = () => {
  if (!awsConfigured) {
    console.warn('Intentando configurar SDK de AWS bajo demanda.');
    configureAwsSdk(); // Intenta configurar si aún no lo está.
  }
  return AWS;
};

// Por compatibilidad, puedes exportar AWS directamente, pero es mejor usar getAwsSdk().
export default AWS; // Nota: Este podría ser un objeto AWS no configurado si se accede demasiado pronto.
